// extracted by mini-css-extract-plugin
export var actionText = "_qe-4";
export var container = "_qe-0";
export var leftSection = "_qe-1";
export var rightSection = "_qe-2";
export var settingsButton = "_qe-6";
export var settingsIcon = "_qe-7";
export var shortcut = "_qe-5";
export var shortcutGroup = "_qe-3";